/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type CoActionNameEnum = (typeof CoActionNameEnum)[keyof typeof CoActionNameEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoActionNameEnum = {
  pay_with_default_payment_method: 'pay_with_default_payment_method',
  add_payment_method: 'add_payment_method',
  change_payment_method: 'change_payment_method',
  pay: 'pay',
  open_payment_modal: 'open_payment_modal',
  open_cancellation_policy_modal: 'open_cancellation_policy_modal',
  open_trust_and_safety_modal: 'open_trust_and_safety_modal',
} as const;
